import axios from "axios";

export const serviceOperationApi = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/ServiceOperation`,
});
